import * as Actions from '../../actions/customerConcerns/type';

const initialState = {
  getCustomerConcernsLoading: false,
  customerConcerns: [],
  getCustomerConcernsError: '',

  getProblemJobTypeListLoading: false,
  getProblemJobTypeList: '',
  getProblemJobTypeListError: '',

  addEditProblemOrJobTypeLoading: false,
  addEditProblemOrJobTypeSuccess: '',
  addEditProblemOrJobTypeError: '',

  deleteProblemOrJobTypeLoading: false,
  deleteProblemOrJobType: '',
  deleteProblemOrJobTypeError: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_CUSTOMER_CONCERNS_REQUEST:
      return {
        ...state,
        getCustomerConcernsLoading: true,
      };
    case Actions.GET_CUSTOMER_CONCERNS_SUCCESS:
      return {
        ...state,
        getCustomerConcernsLoading: false,
        customerConcerns: action.payload?.customerConcerns || [],
      };

    case Actions.GET_CUSTOMER_CONCERNS_FAIL:
      return {
        ...state,
        getCustomerConcernsLoading: false,
        getCustomerConcernsError: action.payload,
      };
    case Actions.UPDATE_CUSTOMER_CONCERNS:
      return {
        ...state,
        customerConcerns: action.payload || [],
      };

    // get problem and job type list
    case Actions.GET_PROBLEM_AND_JOB_TYPE_LIST_REQUEST:
      return {
        ...state,
        getProblemJobTypeListLoading: true,
      };
    case Actions.GET_PROBLEM_AND_JOB_TYPE_LIST_SUCCESS:
      return {
        ...state,
        getProblemJobTypeListLoading: false,
        getProblemJobTypeList: action.payload || '',
      };

    case Actions.GET_PROBLEM_AND_JOB_TYPE_LIST_FAIL:
      return {
        ...state,
        getProblemJobTypeListLoading: false,
        getProblemJobTypeListError: action.payload,
      };
    case Actions.CLEAR_GET_PROBLEM_AND_JOB_TYPE_LIST_STATES:
      return {
        ...state,
        getProblemJobTypeListLoading: false,
        getProblemJobTypeList: '',
        getProblemJobTypeListError: '',
      };

    // add or edit problem or job type
    case Actions.ADD_EDIT_PROBLEM_OR_JOB_TYPE_REQUEST:
      return {
        ...state,

        addEditProblemOrJobTypeLoading: true,
      };
    case Actions.ADD_EDIT_PROBLEM_OR_JOB_TYPE_SUCCESS:
      return {
        ...state,
        addEditProblemOrJobTypeLoading: false,
        addEditProblemOrJobTypeSuccess: action.payload || '',
      };

    case Actions.ADD_EDIT_PROBLEM_OR_JOB_TYPE_FAIL:
      return {
        ...state,
        addEditProblemOrJobTypeLoading: false,
        addEditProblemOrJobTypeError: action.payload,
      };
    case Actions.CLEAR_ADD_EDIT_PROBLEM_OR_JOB_TYPE_STATES:
      return {
        ...state,
        addEditProblemOrJobTypeLoading: false,
        addEditProblemOrJobTypeSuccess: '',
        addEditProblemOrJobTypeError: '',
      };

    // delete problem and job type list
    case Actions.DELETE_PROBLEM_OR_JOB_TYPE_REQUEST:
      return {
        ...state,
        deleteProblemOrJobTypeLoading: action.payload,
      };
    case Actions.DELETE_PROBLEM_OR_JOB_TYPE_SUCCESS:
      return {
        ...state,
        deleteProblemOrJobType: action.payload,
      };

    case Actions.DELETE_PROBLEM_OR_JOB_TYPE_FAIL:
      return {
        ...state,
        deleteProblemOrJobTypeError: action.payload,
      };
    case Actions.CLEAR_DELETE_PROBLEM_OR_JOB_TYPE_STATES:
      return {
        ...state,
        deleteProblemOrJobTypeLoading: false,
        deleteProblemOrJobType: '',
        deleteProblemOrJobTypeError: '',
      };

    default:
      return state;
  }
}
